import getSafeWindowHeight from './getSafeWindowHeight';

// Why "safe"? See `getSafeWindowHeight`
export default function convertVhToPxSafe(input: number): number {
  return (getSafeWindowHeight() * input) / 100;
}
